module.exports = __webpack_public_path__ + "static/media/building.7729a687.svg";